<template>
  <fin-choose-selector v-model="dialog"
                       :new-list-creation-enabled="true"
                       :options="watchlists"
                       :check-if-new-item-creation-allowed="checkIfNewWatchlistCreationAllowed"
                       :new-item-creation-not-allowed-action="newWatchlistCreationNotAllowed"
                       introTextNewList="Wie soll deine Watchlist heißen?"
                       labelHint="Wähle eine Watchlist"
                       newListLabel="Neue Watchlist anlegen"
                       select-box-item-title="name"
                       select-box-item-value="id"
                       select-box-title="Watchlists"
                       title="Wähle eine Watchlist aus"
                       @closeChooseSelector="$emit('closeAddToWatchlist')"
                       @createNewItem="(watchlistname) => addSelectedItemsToNewWatchlist(watchlistname)"
                       @submitSelectedItem="(watchlistid) => addSelectedInstrumentsToWatchlist(watchlistid, false)"
  />
</template>

<script>
import {finWatchlistAPI} from '@/js/finAPI'
import FinChooseSelector from '@/components/common/ChooseSelector'
import {mapGetters} from 'vuex'
import {PRICEMODEL_FEATURE_IDS, PRICEMODEL_FEATURE_RESTRICTIONS} from "@/js/finPriceModel"
import {EventBus} from "@/plugins/fincraft"
import PriceModel from "@/mixins/PriceModel"

export default {
  name: 'FinAddToWatchlist',
  components: {FinChooseSelector},
  props: {
    addToWatchlist: {
      type: Boolean,
      default: false
    },
    selectedInstruments: {
      type: Array
    }
  },
  data() {
    return {
      watchlists: [],
      dialog: this.addToWatchlist
    }
  },
  mixins: [PriceModel],
  computed: {
    ...mapGetters('auth', ['userId']),
  },
  methods: {
    async loadWatchlists() {
      await finWatchlistAPI.listWatchlists(this.userId).then((mywatchlists) => {
        if (mywatchlists) {
          this.watchlists = mywatchlists
        }
      })
    },
    checkIfNewWatchlistCreationAllowed() {
      return this.priceModelEnabledAndLimit(PRICEMODEL_FEATURE_IDS.WATCHLIST.id) &&
        this.watchlists.length < this.priceModelEnabledAndLimit(PRICEMODEL_FEATURE_IDS.WATCHLIST.id)
    },
    newWatchlistCreationNotAllowed() {
      let newCount = this.watchlists.length
      EventBus.$emit('showSubscriptionPopup', PRICEMODEL_FEATURE_IDS.WATCHLIST.id, PRICEMODEL_FEATURE_RESTRICTIONS.QUANTITY, {itemAmount: ++newCount})
    },
    async createNewWatchlist(name) {
      try {
        return await finWatchlistAPI.createWatchlist({'name': name})
      } catch (e) {
        this.$toasted.global.finToast({
          message: 'Deine Watchlist %name% konnte nicht erstellt werden',
          placeholders: [{name: "name", content: name}],
          type: 'error'
        })
      }

    },
    async addSelectedInstrumentsToWatchlist(watchlistId, isNewList) {
      const promises = []
      for (let i = 0; i < this.selectedInstruments.length; i++) {
        const currInstr = this.selectedInstruments[i]
        const wlEntryObjectId = currInstr.id ? currInstr.id : currInstr.instrumentId

        if (wlEntryObjectId) {
          console.log("selectedInstruments[i]", currInstr, wlEntryObjectId)
          promises.push(finWatchlistAPI.createWatchlistEntry(watchlistId, wlEntryObjectId))
        } else {
          console.log("neither id nor instrumentId is set => unable to add instrument to watchlist", watchlistId, currInstr)
        }
      }

      try {
        await Promise.all(promises)
        if (this.selectedInstruments.length > 0) {
          console.log("added instruments:", this.selectedInstruments.length)

          let toastedNotifText
          if (this.selectedInstruments.length > 1) {
            toastedNotifText = isNewList ? 'Die Watchliste wurde mit den ausgewählten Wertpapieren erstellt.' : 'Die ausgewählten Wertpapiere wurden übernommen.'
          } else {
            toastedNotifText = isNewList ? 'Die Watchliste wurde mit dem ausgewählten Wertpapier erstellt.' : 'Das ausgewählte Wertpapier wurde übernommen.'
          }
          this.$toasted.global.finToast({
            message: toastedNotifText,
            type: 'success',
            options: {
              action: {
                text: 'Zur Watchlist',
                push: {name: 'watchlistDetails', params: {id: watchlistId}}
              }
            }
          })
        }
      } catch (e) {
        console.error("failed to add watchlistEntry to watchlist", e)
        let toastedNotifText
        if (e.errors[0].message === 'The conditional request failed') {
          if (this.selectedInstruments.length > 1) {
            toastedNotifText = 'Die ausgewählten Wertpapiere wurden übernommen. Teilweise waren diese bereits in der Watchlist.'
          } else {
            toastedNotifText = 'Das Wertpapier ist in der Watchlist bereits vorhanden.'
          }
          this.$toasted.global.finToast({
            message: toastedNotifText,
            type: 'info'
          })
        } else {
          if (this.selectedInstruments.length > 1) {
            toastedNotifText = 'Die ausgewählten Wertpapiere konnten nicht übernommen werden.'
          } else {
            toastedNotifText = 'Das ausgewählte Wertpapier konnte nicht übernommen werden.'
          }
          this.$toasted.global.finToast({
            message: 'Die ausgewählten Wertpapiere konnten nicht übernommen werden.',
            type: 'error',
          })
        }
      }
    },
    // watchlist is either the id of an existing watchlist or the name of a new watchlist
    async addSelectedItemsToNewWatchlist(watchlist) {
      // create Watchlist
      const newItem = await this.createNewWatchlist(watchlist)

      this.watchlists.push(newItem)

      // add selectedInstruments to watchlist
      if (newItem.id !== undefined) {
        await this.addSelectedInstrumentsToWatchlist(newItem.id, true)
      } else {
        console.error("cannot update watchlist (watchlistId is undefined)", watchlist)
      }
    }
  },
  watch: {
    addToWatchlist(val) {
      if (val) {
        this.watchlists = []
        this.loadWatchlists()
      }
      this.dialog = val
    }
  },
}
</script>

<style lang="scss" scoped>

</style>
